import { useState } from 'react';
import { hotReviews } from '@/mocks/zh/home';

export default function UserReviews() {
  const [current, setCurrent] = useState(0);
  const review = hotReviews[current];

  const goNext = () => setCurrent((prev) => (prev + 1) % hotReviews.length);
  const goPrev = () => setCurrent((prev) => (prev - 1 + hotReviews.length) % hotReviews.length);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10">
          （ 吃瓜群众热评 ）
        </h2>

        <div className="relative">
          <div className="inline-flex items-center gap-1.5 mb-5 px-3 py-1.5 rounded-full bg-primary-50">
            <i className="ri-star-fill text-primary-500 text-sm"></i>
            <span className="text-sm font-semibold text-primary-700">{review.rating}</span>
          </div>

          <blockquote className="text-lg md:text-xl font-heading text-foreground-800 leading-relaxed mb-8 italic">
            {review.content}
          </blockquote>

          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="w-11 h-11 md:w-12 md:h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
              <img
                src={review.avatar}
                alt={review.userName}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="text-left">
              <div className="text-sm font-semibold text-foreground-900">{review.userName}</div>
              <div className="text-xs text-foreground-500">{review.level}</div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3">
            <button
              onClick={goPrev}
              className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg border border-background-300 text-foreground-600 hover:text-foreground-900 hover:border-foreground-400 transition-all cursor-pointer"
              aria-label="上一条评价"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <div className="flex items-center gap-1.5">
              {hotReviews.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrent(idx)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    idx === current ? 'bg-primary-500 w-5' : 'bg-background-300 hover:bg-background-400'
                  }`}
                  aria-label={`第${idx + 1}条评价`}
                />
              ))}
            </div>
            <button
              onClick={goNext}
              className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-foreground-950 text-white hover:bg-foreground-800 transition-all cursor-pointer"
              aria-label="下一条评价"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}